// 当前panel显示的是哪个tab
export var E_LoginPanelTab;
(function (E_LoginPanelTab) {
    E_LoginPanelTab["login"] = "login";
    E_LoginPanelTab["verify"] = "verify";
})(E_LoginPanelTab || (E_LoginPanelTab = {}));
